import React from 'react';
import {Grid, Row, Col} from '@/grid';
import Container from '@/container';
import {SectionPadding} from '@/section';
import {H2} from '@/typography';
import {withBgOrange50} from '@/hocs/withColors';
import {withBoldWeight, withPMarginMd} from '@/hocs/withFontType';
import {withMarginBottomZeroToXxl} from '@/hocs/withSpacing';
import PictureWrapper from '@/ui/images-wrapper';
import Link from '@/links';
import {useTranslations} from 'next-intl';

const Orange50Section = withBgOrange50(SectionPadding);
const BoldSpan = withBoldWeight('span');
const PMarginMd = withPMarginMd('p');
const LinkMarginMob = withMarginBottomZeroToXxl(Link);

const imgPath = '/static/images/about/';

const WhatWeDo = () => {
  const t = useTranslations('about.whatWeDo');

  return (
    <Orange50Section>
      <Container>
        <Grid fluid>
          <Row middle="xs" center="xs" start="lg">
            <Col xs={12} lg={6}>
              <PictureWrapper
                imgPath={imgPath}
                imageUrl="what-we-do"
                imageTypeFallback="jpg"
                alt={t('imageAlt')}
              />
            </Col>
            <Col xs={12} lg={5} lgOffset={1} first="xs" last="lg">
              <H2>{t('title')}</H2>
              <PMarginMd>
                {t.rich('description', {
                  bold: chunks => <BoldSpan>{chunks}</BoldSpan>
                })}
              </PMarginMd>
              <LinkMarginMob
                href="//get.workable.com/awards"
                variant="cta-default-xs"
                target="_blank">
                {t('linkText')}
              </LinkMarginMob>
            </Col>
          </Row>
        </Grid>
      </Container>
    </Orange50Section>
  );
};

export default WhatWeDo;
